import React from 'react';
import { FormState } from '../../types';
import { Card, CardContent } from '../ui/Card';
import { Mail } from 'lucide-react';
interface Props {
  state: FormState;
}
export function NotificationSummary({
  state
}: Props) {
  return <Card className="bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 shadow-inner" data-id="element-224">
      <CardContent className="p-6" data-id="element-225">
        <div className="flex items-center space-x-3 mb-4" data-id="element-226">
          <div className="p-2 bg-indigo-100 dark:bg-indigo-900/50 rounded-lg" data-id="element-227">
            <Mail className="w-5 h-5 text-indigo-600 dark:text-indigo-400" data-id="element-228" />
          </div>
          <div data-id="element-229">
            <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100" data-id="element-230">
              Notification Preview
            </h3>
            <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-231">
              The following people will be notified upon submission.
            </p>
          </div>
        </div>

        <div className="space-y-2 text-sm bg-white dark:bg-slate-900 p-4 rounded-md border border-slate-200 dark:border-slate-700" data-id="element-232">
          <div className="flex" data-id="element-233">
            <span className="w-16 font-medium text-slate-500 dark:text-slate-400" data-id="element-234">
              To:
            </span>
            <span className="text-slate-900 dark:text-slate-100" data-id="element-235">
              disclosureteam@madisonmortgage.com
            </span>
          </div>
          <div className="flex" data-id="element-236">
            <span className="w-16 font-medium text-slate-500 dark:text-slate-400" data-id="element-237">
              CC:
            </span>
            <span className="text-slate-900 dark:text-slate-100" data-id="element-238">
              {state.loanOfficerEmail || 'LO Email'}
            </span>
          </div>
          {state.loaEmail && <div className="flex" data-id="element-239">
              <span className="w-16 font-medium text-slate-500 dark:text-slate-400" data-id="element-240">
                CC:
              </span>
              <span className="text-slate-900 dark:text-slate-100" data-id="element-241">
                {state.loaEmail}
              </span>
            </div>}
          {state.loa2Email && <div className="flex" data-id="element-242">
              <span className="w-16 font-medium text-slate-500 dark:text-slate-400" data-id="element-243">
                CC:
              </span>
              <span className="text-slate-900 dark:text-slate-100" data-id="element-244">
                {state.loa2Email}
              </span>
            </div>}
          <div className="flex" data-id="element-245">
            <span className="w-16 font-medium text-slate-500 dark:text-slate-400" data-id="element-246">
              BCC:
            </span>
            <span className="text-slate-900 dark:text-slate-100" data-id="element-247">
              internal-logs@madisonmortgage.com
            </span>
          </div>
        </div>
      </CardContent>
    </Card>;
}